module.exports = __webpack_public_path__ + "img/dljl-select.aab43629.png";